var _circle, _circle2, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle3, _circle4, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 218,
    viewBox: "0 0 217 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.0567,
    cy: 73.0567,
    r: 73.0567,
    transform: "matrix(-1 0 0 1 180.833 36.6665)",
    fill: "#094752"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 80.29,
    cy: 80.29,
    r: 78.79,
    transform: "matrix(-1 0 0 1 188.066 29.4331)",
    stroke: "#BAE0E2",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7057 145.167C97.6037 145.171 95.5574 144.479 93.8755 143.195L93.7712 143.116L71.815 126.003C70.7982 125.21 69.9448 124.22 69.3035 123.092C68.6622 121.963 68.2456 120.716 68.0775 119.424C67.9094 118.131 67.9931 116.817 68.3238 115.557C68.6544 114.297 69.2256 113.116 70.0047 112.081C70.7838 111.046 71.7556 110.177 72.8645 109.524C73.9734 108.871 75.1978 108.447 76.4677 108.276C77.7376 108.105 79.0282 108.19 80.2658 108.527C81.5034 108.864 82.6637 109.445 83.6806 110.238L97.9021 121.339L131.51 76.7214C132.289 75.6865 133.261 74.8181 134.371 74.1656C135.48 73.5132 136.704 73.0896 137.974 72.9189C139.244 72.7482 140.535 72.8339 141.772 73.171C143.01 73.5081 144.17 74.09 145.186 74.8835L144.977 75.1723L145.192 74.8877C147.242 76.4921 148.584 78.8589 148.922 81.469C149.261 84.079 148.569 86.7192 146.997 88.8102L107.466 141.291C106.552 142.501 105.376 143.48 104.03 144.152C102.685 144.824 101.205 145.171 99.7057 145.167Z",
    fill: "#F2F2F2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.9534,
    cy: 28.1316,
    rx: 8.554,
    ry: 8.554,
    fill: "#BAE0E2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.6851,
    cy: 24.1836,
    rx: 4.606,
    ry: 4.606,
    fill: "#BAE0E2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.4732,
    cy: 59.7154,
    rx: 4.606,
    ry: 4.606,
    fill: "#BAE0E2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.707,
    cy: 106.434,
    rx: 6.58,
    ry: 6.58,
    fill: "#BAE0E2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9966,
    cy: 164.996,
    rx: 4.606,
    ry: 4.606,
    fill: "#BAE0E2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3954,
    cy: 194.605,
    rx: 6.58,
    ry: 6.58,
    fill: "#BAE0E2"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.507,
    cy: 198.553,
    rx: 2.632,
    ry: 2.632,
    fill: "#BAE0E2"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.381,
    cy: 205.791,
    rx: 5.922,
    ry: 5.922,
    fill: "#BAE0E2"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.991,
    cy: 197.238,
    rx: 3.948,
    ry: 3.94801,
    fill: "#BAE0E2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.181,
    cy: 182.104,
    r: 5.922,
    fill: "#BAE0E2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.393,
    cy: 154.467,
    r: 3.29,
    fill: "#BAE0E2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.237,
    cy: 129.463,
    rx: 3.29,
    ry: 3.29,
    fill: "#BAE0E2"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.947,
    cy: 80.1132,
    rx: 6.57999,
    ry: 6.58,
    fill: "#BAE0E2"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.523,
    cy: 72.2175,
    rx: 3.94801,
    ry: 3.948,
    fill: "#BAE0E2"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.255,
    cy: 36.6853,
    rx: 3.948,
    ry: 3.948,
    fill: "#BAE0E2"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.407,
    cy: 11.6814,
    rx: 3.948,
    ry: 3.948,
    fill: "#BAE0E2"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.259,
    cy: 27.4736,
    rx: 6.58,
    ry: 6.58,
    fill: "#BAE0E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.d62e544ae3032b2f21dfb2af96c11a2f.svg";
export { ForwardRef as ReactComponent };